import React from 'react';

import './home-intro.css';

// Titolo (h1) e testo della home, mostrati sopra le slide
const HomeIntro = ({ title, text, color }) => {
  if (!title && !text) return null;

  return (
    <section className="home-intro" style={{ color: color || undefined }}>
      {title && <h1 className="home-intro-title">{title}</h1>}
      {text && <p className="home-intro-text">{text}</p>}
    </section>
  );
};

export default HomeIntro;
